import React from 'react';
import { Icon } from 'semantic-ui-react';
import { useToastStore } from '../../stores/useToastStore';
import './ToastContainer.css';

/**
 * Toast notification item
 */
const ToastItem = ({ toast, onDismiss }) => {
  const iconMap = {
    success: 'check circle',
    error: 'times circle',
    warning: 'exclamation triangle',
    info: 'info circle',
  };

  const colorMap = {
    success: '#21ba45',
    error: '#db2828',
    warning: '#f2711c',
    info: '#2185d0',
  };

  return (
    <div
      className={`toast-item toast-${toast.type}`}
      style={{ '--toast-color': colorMap[toast.type] }}
    >
      <Icon name={iconMap[toast.type]} />
      <span className="toast-message">{toast.message}</span>
      {toast.action && (
        <button
          className="toast-action"
          onClick={() => {
            toast.onAction?.();
            onDismiss(toast.id);
          }}
        >
          {toast.action}
        </button>
      )}
      <button className="toast-dismiss" onClick={() => onDismiss(toast.id)}>
        <Icon name="close" />
      </button>
    </div>
  );
};

/**
 * Toast Container - Renders all active toasts
 * Place this component once at the app root level
 */
const ToastContainer = () => {
  const toasts = useToastStore((state) => state.toasts);
  const removeToast = useToastStore((state) => state.removeToast);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onDismiss={removeToast} />
      ))}
    </div>
  );
};

export default ToastContainer;
